import { useEffect } from 'react'
import { portalMode } from '@/lib/portal'
import { usePortalSite } from './portal-site'

/** The browser tab shows the agency, not Arva SEO, on its portal address. */
export function PortalDocumentBranding() {
  const site = usePortalSite()

  useEffect(() => {
    if (!portalMode) return
    document.title = site?.name ?? ''
    const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    // The agency's logo, or a plain dot in its colour until it loads.
    const fallback = `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7" fill="${site?.color ?? '#0B0C0A'}"/></svg>`,
    )}`
    if (icon) {
      icon.type = site?.logo ? '' : 'image/svg+xml'
      icon.href = site?.logo ?? fallback
    }
    document.querySelector('link[rel="apple-touch-icon"]')?.remove()
  }, [site])

  return null
}
